/*
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
 */
import { defineStore } from "pinia";

/**
 * A Pinia store for managing user preferences.
 *
 * This store provides a reactive state that allows components
 * to access and update user preference data, such as the
 * preferred view option.
 *
 * The state is structured to contain:
 * - `listView`: A boolean indicating whether the user prefers
 *   a list view or not.
 *
 * The store's unique identifier is "UserPreferencesStore".
 */
export const useUserPreferencesStore = defineStore({
  id: "UserPreferencesStore",
  state: () => ({
    listView: true,
  }),
});
